import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
/** Reducers Import */
import { MenuActions } from "../services/Redux/MenuReducer";
/** Services Import */
import Commons from "../services/Common/Common";
import IndexedDb from "../services/IndexedDb/IndexedDb";
/** Components Import */
import Header from "../Components/Header/Index";
import Sidebar from "../Components/Sidebar";
import { Container } from "react-bootstrap";
import BottomTabs from "../Components/BottomTabs";
/** Images Import */
import Logo from "../Assets/Images/busanbus_logo.png";
/** Icons Import */
import {
  faBusSimple,
  faCouch,
  faChalkboardUser,
  faUserTie,
  faGear,
  faRecycle,
  faCarBurst,
  faScrewdriverWrench,
  faBoxesStacked,
  faTv,
} from "@fortawesome/free-solid-svg-icons";

function Drawer() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuStates = useSelector((state) => state.Menus);
  const [userInfo, setUserInfo] = useState(null);
  const [sideShow, setSideShow] = useState(false);
  const [tabsValue, setTabsValue] = useState("");
  const [tabList, setTabList] = useState([]);

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (location.pathname.length > 0) {
      if (location.pathname == "/AutoDispatch") {
        setTabsValue("AutoDispatch");
        dispatch(MenuActions.setLargeTitle("자동배차"));
      } else if (location.pathname == "/Holiday") {
        setTabsValue("Holiday");
        dispatch(MenuActions.setLargeTitle("휴무관리"));
      } else if (location.pathname == "/Education") {
        setTabsValue("Education");
        dispatch(MenuActions.setLargeTitle("교육관리"));
      } else if (location.pathname == "/AddWork") {
        setTabsValue("AddWork");
        dispatch(MenuActions.setLargeTitle("근무신청"));
      } else if (location.pathname == "/ChangeCar") {
        setTabsValue("ChangeCar");
        dispatch(MenuActions.setLargeTitle("대차처리"));
      } else if (location.pathname == "/AccidentCar") {
        setTabsValue("AccidentCar");
        dispatch(MenuActions.setLargeTitle("사고·고장처리"));
      } else if (location.pathname == "/EmptyCar") {
        setTabsValue("EmptyCar");
        dispatch(MenuActions.setLargeTitle("공차 운행"));
      } else if (location.pathname == "/AdminAutoDispatch") {
        setTabsValue("AdminAutoDispatch");
        dispatch(MenuActions.setLargeTitle("배차관리"));
      } else if (location.pathname == "/Mornitoring") {
        setTabsValue("Mornitoring");
        dispatch(MenuActions.setLargeTitle("모니터링"));
      } else if (location.pathname == "/AdminEducation") {
        setTabsValue("AdminEducation");
        dispatch(MenuActions.setLargeTitle("교육관리"));
      } else if (location.pathname == "/AdminHoliday") {
        setTabsValue("AdminHoliday");
        dispatch(MenuActions.setLargeTitle("휴무관리"));
      } else if (location.pathname == "/AdminAddWork") {
        setTabsValue("AdminAddWork");
        dispatch(MenuActions.setLargeTitle("근무관리"));
      } else if (location.pathname == "/AdminFacilities") {
        setTabsValue("AdminFacilities");
        dispatch(MenuActions.setLargeTitle("시설물"));
      } else if (location.pathname == "/Setting") {
        setTabsValue("");
        dispatch(MenuActions.setLargeTitle("Setting"));
      } else if (location.pathname == "/Notices") {
        setTabsValue("");
        dispatch(MenuActions.setLargeTitle("공지사항"));
      }
    }
  }, [location]);

  const Init = async () => {
    let userData = null;

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userData = result;
        setUserInfo(result);
      });

      if (userData.authorityId == "1") {
        setTabList([
          {
            value: "AutoDispatch",
            text: "자동배차",
            icon: faBusSimple,
            onClick: () => navigate("/AutoDispatch"),
          },
          {
            value: "Holiday",
            text: "휴무관리",
            icon: faCouch,
            onClick: () => navigate("/Holiday"),
          },
          {
            value: "Education",
            text: "교육관리",
            icon: faChalkboardUser,
            onClick: () => navigate("/Education"),
          },
          {
            value: "AddWork",
            text: "근무신청",
            icon: faUserTie,
            onClick: () => navigate("/AddWork"),
          },
          {
            value: "Setting",
            text: "Setting",
            icon: faGear,
            onClick: () => navigate("/Setting"),
          },
        ]);
      } else if (userData.authorityId == "2") {
        setTabList([
          {
            value: "ChangeCar",
            text: "대차처리",
            icon: faRecycle,
            onClick: () => navigate("/ChangeCar"),
          },
          {
            value: "AccidentCar",
            text: "사고·고장처리",
            icon: faCarBurst,
            onClick: () => navigate("/AccidentCar"),
          },
          {
            value: "EmptyCar",
            text: "공차 운행",
            icon: faScrewdriverWrench,
            onClick: () => navigate("/EmptyCar"),
          },
          {
            value: "Setting",
            text: "Setting",
            icon: faGear,
            onClick: () => navigate("/Setting"),
          },
        ]);
      } else if (userData.authorityId == "7") {
        setTabList([
          {
            value: "AdminAutoDispatch",
            text: "배차관리",
            icon: faBusSimple,
            onClick: () => navigate("/AdminAutoDispatch"),
          },
          {
            value: "Mornitoring",
            text: "모니터링",
            icon: faTv,
            onClick: () => navigate("/Mornitoring"),
          },
          {
            value: "AdminFacilities",
            text: "시설물",
            icon: faBoxesStacked,
            onClick: () => navigate("/AdminFacilities"),
          },
          {
            value: "AdminHoliday",
            text: "휴무관리",
            icon: faCouch,
            onClick: () => navigate("/AdminHoliday"),
          },
          {
            value: "AdminAddWork",
            text: "근무관리",
            icon: faUserTie,
            onClick: () => navigate("/AdminAddWork"),
          },
          {
            value: "AdminEducation",
            text: "교육관리",
            icon: faChalkboardUser,
            onClick: () => navigate("/AdminEducation"),
          },
          {
            value: "Setting",
            text: "Setting",
            icon: faGear,
            onClick: () => navigate("/Setting"),
          },
        ]);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  return (
    <React.Fragment>
      <Header
        logo={Logo}
        title={menuStates.largeTitle}
        onShow={() => setSideShow(true)}
      >
        <Sidebar
          title="운행관리 표준화 시스템"
          items={tabList}
          show={sideShow}
          onHide={() => setSideShow(false)}
        />
      </Header>
      <Container className="main-container" fluid>
        <Outlet />
      </Container>
      <BottomTabs
        items={tabList}
        value={tabsValue}
        onSelect={(e) => setTabsValue(e)}
      />
    </React.Fragment>
  );
}

export default Drawer;
